@if(isActive()) {
    <kui-tabs (tabChanged)="handleTabChange($event)">
        @for (camera of cameras(); track camera.cameraId; let first = $first) {
            <kui-tab [title]="camera.cameraName" [isActive]="first">
                <key-livestream
                    class="flex-1 video-player"
                    [class.hidden]="camera.cameraName !== activeCamera()"
                    [assetId]="camera.assetId"
                    [camera]="camera.cameraId"
                    duration="60">
                </key-livestream>
            </kui-tab>
        }
    </kui-tabs>
} @else {
    <div>
        {{ "MEDIA.LIVESTREAM.UNABLE_ACTIVITY" | translate }}
    </div>
}